import personalizeService from '../utils/rbmc.personalizeService';
import 'bootstrap-select';

const footer = {
    settings: {
        country:  personalizeService.getCountry(),
        language: personalizeService.getLanguage(),
        currency: null
    },
    initFooterFlag() {
        let src = `/_ui/responsive/theme-rbmc/images/flags/${personalizeService.getCountry()}.svg`;
        $('#js-page-footer__flag').attr('src', src);
        $('#js-page-footer__flag').attr('loading', 'lazy');
    },
    buildSelectMenu() {
        $('.form-control--select-modal').selectpicker({
            style: 'btn-select'
        });
    },
    bindHandler() {
        $('#settings-country').on('changed.bs.select', (e, clickedIndex) => {
            this.settings.country = e.target.value.toLowerCase();
            let dataSet           = e.target[clickedIndex].dataset;
            $('.currency--name').text(dataSet.currencyName);
            $('.currency--symbol').text(dataSet.currencySymbol);
        });
        $('#settings-language').on('changed.bs.select', (e) => {
            this.settings.language = e.target.value;
        });
        $('#js-update-settings').on('click', () => {
            let restPath         = window.location.pathname.substring(6);
            window.location.href = `${window.location.origin}/${this.settings.language}-${this.settings.country}${restPath}`;
        });
    }
};

$(() => {
    footer.initFooterFlag();
    if ($('#settingsModal').length) {
        footer.buildSelectMenu();
        footer.bindHandler();
    }
});

export default footer;
